import http from "@seims/shared/src/services/HttpService";

var apiEndpoint = `system/configurations`;
var apiAddressEndpoint = 'system/invalid/addresses';


const headers = {};

const getConfigs = async () => {
    const response = await http.get(`${apiEndpoint}`,
        { headers: headers }
    );
    return response;
};

const getInvalidAddresses = async () => {
    const response = await http.get(`${apiAddressEndpoint}`,
        { headers: headers }
    );
    return response;
};

const getInvalidAddress = async (id) => {
    const response = await http.get(`${apiAddressEndpoint}/${id}`,
        { headers: headers }
    );
    return response;
};
const updateConfigs = async (values) => {
    const response = await http.put(`${apiEndpoint}`, values,
        { headers: headers }
    );
    return response;
};
const updateAddress = async (id, values) => {
    const response = await http.put(`${apiAddressEndpoint}/${id}`, values,
        { headers: headers }
    );
    return response;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getConfigs,
    updateConfigs,
    getInvalidAddress,
    getInvalidAddresses,
    updateAddress
}  